module.exports = __webpack_public_path__ + "static/media/mn.d050c565.svg";